import { render } from "./AlterarSenha.vue?vue&type=template&id=593b281e&scoped=true"
import script from "./AlterarSenha.vue?vue&type=script&lang=js"
export * from "./AlterarSenha.vue?vue&type=script&lang=js"

import "./AlterarSenha.vue?vue&type=style&index=0&id=593b281e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593b281e"]])

export default __exports__